
import Modal from '~/components/Modules/Common/Modal'
import NuxtImage from '~/components/Modules/Common/NuxtImage'

export default {
  components: { Modal, NuxtImage },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentSlide: 0,
      modalData: [],
      isNavControls: false,
      delayedCall: null,
      showModal: false,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init() {
      this.delayedCall = this.$gsap.delayedCall(0.7, () => {
        this.stopAnimation()
      })
      this.setIndicatorCoords(0)

      // watch for current slide
      this.$watch('$refs.carousel.currentSlide', (newSlide) => {
        this.currentSlide = newSlide
      })
    },
    setModalData(data) {
      this.modalData = data
      this.openModal()
    },
    openModal() {
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
    handleClick(index) {
      // reset tweens if carousel nav button is clicked again
      this.delayedCall.kill()

      this.startAnimation()

      this.$refs.carousel.changeSlide(index, () =>
        this.setIndicatorCoords(index)
      )

      // delaycall to match animation length: .7s
      // determines when scrolling is fininshed
      this.delayedCall = this.$gsap.delayedCall(0.7, () => {
        this.stopAnimation()
      })
    },
    handleScroll(i) {
      // callback for scroll listener
      // stop scroll listener from firing when nav is clicked to avoid conflicting animation calls
      !this.isNavControls && this.setIndicatorCoords(i)
    },

    startAnimation() {
      this.isNavControls = true
    },

    stopAnimation() {
      this.isNavControls = false
    },

    setIndicatorCoords(i) {
      const displayedIndicator = this.$refs.displayIndicator
      const navCoords = this.$refs.carouselNav?.getBoundingClientRect()
      const nextIndicator = this.$refs[i][0]?.getBoundingClientRect()

      if (!nextIndicator || !navCoords) {
        return
      }

      const left = nextIndicator.left - navCoords.left

      displayedIndicator.style.setProperty('transform', `translate(${left}px`)
    },
  },
}
